import type { Router } from "@/typeDefinitions/custom/Router";
import { SQDCEventActionTypeInternalType, SQDCEventActionTypePreset } from "@/graphql";

const router: Router.LicensedRouterExportType = [
  {
    path: "/quality/productFamilies",
    name: "QAProductFamilies",
    component: () => import("./views/QAProductFamilies.vue"),
    meta: {
      rights: ["quality.admin"],
    },
  },
  {
    path: "/quality/productFamily/new",
    name: "QACreateProductFamily",
    component: () => import("./views/QACreateProductFamily.vue"),
    meta: {
      rights: ["quality.admin"],
    },
  },
  {
    path: "/quality/productFamily/update/:id",
    name: "QAUpdateProductFamily",
    component: () => import("./views/QAUpdateProductFamily.vue"),
    props: (route) => {
      return {
        productFamilyId: parseInt(route.params.id.toString(), 10),
      };
    },
    meta: {
      rights: ["quality.admin"],
      authorizationSiteResource: "qaProductFamily",
    },
  },
  {
    path: "/quality/errorCatalogs",
    name: "QAErrorCatalogs",
    component: () => import("./views/QAErrorCatalogs.vue"),
    meta: {
      rights: ["quality.admin"],
    },
  },
  {
    path: "/quality/errorCatalogue/new",
    name: "QACreateErrorCatalogue",
    component: () => import("./views/QACreateErrorCatalogue.vue"),
    meta: {
      rights: ["quality.admin"],
    },
  },
  {
    path: "/quality/errorCatalogue/update/:id",
    name: "QAUpdateErrorCatalogue",
    component: () => import("./views/QAUpdateErrorCatalogue.vue"),
    props: (route) => {
      return {
        errorCatalogueId: parseInt(route.params.id.toString(), 10),
      };
    },
    meta: {
      rights: ["quality.admin"],
      authorizationSiteResource: "qaErrorCatalogue",
    },
  },
  {
    path: "/quality/settings",
    name: "QASettings",
    component: () => import("./views/QASettings.vue"),
    meta: {
      rights: ["quality.admin"],
    },
  },
  {
    path: "/quality/configOverview",
    name: "QualityConfigOverview",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigOverview.vue"),
    meta: {
      rights: ["quality.admin"],
    },
    props: {
      internalType: SQDCEventActionTypeInternalType.Quality,
      presets: [SQDCEventActionTypePreset.Quality],
      titleKey: "router.QualityConfigOverview",
      siteOverviewRouteName: "QualitySiteConfigOverview",
    },
  },
  {
    path: "/quality/configOverview/sites",
    name: "QualitySiteConfigOverview",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeSiteOverview.vue"),
    meta: {
      rights: ["quality.admin"],
    },
    props: {
      internalTypes: [SQDCEventActionTypeInternalType.Quality],
      titleKey: "router.QualityConfigOverview",
      detailRouteName: "QualityConfigSettings",
      requiredRight: "quality.admin",
    },
  },
  {
    path: "/quality/configOverview/sites/:siteId",
    name: "QualityConfigSettings",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigSettings.vue"),
    props: (route) => ({
      internalTypes: [SQDCEventActionTypeInternalType.Quality],
      siteId: parseInt(route.params.siteId.toString(), 10),
      titleKey: "router.QualityConfigSettings",
    }),
    meta: {
      rights: ["quality.admin"],
    },
  },
  {
    path: "/quality/setting/site/:id",
    name: "QASetting",
    component: () => import("./views/QASetting.vue"),
    props: (route) => {
      return {
        siteId: parseInt(route.params.id.toString(), 10),
      };
    },
    meta: {
      rights: ["quality.admin"],
    },
  },
  {
    path: "/chart/pareto",
    name: "QAChartPareto",
    component: () => import("./views/QAChartPareto.vue"),
  },
  {
    path: "/quality/qaChecklists",
    name: "QAChecklists",
    component: () => import("./views/QAChecklists.vue"),
    meta: {
      rights: ["quality.admin"],
    },
  },
  {
    path: "/quality/qaChecklistCreate/:siteId",
    name: "QACreateChecklist",
    component: () => import("./views/QACreateChecklist.vue"),
    meta: {
      rights: ["quality.admin"],
    },
    props: (route) => {
      return {
        siteId: parseInt(route.params.siteId.toString(), 10),
        copyChecklistId:
          route.query.copyChecklistId != null
            ? parseInt(route.query.copyChecklistId.toString(), 10)
            : null,
      };
    },
  },
  {
    path: "/quality/qaChecklistUpdate/:id",
    name: "QAUpdateChecklist",
    component: () => import("./views/QAUpdateChecklist.vue"),
    meta: {
      rights: ["quality.admin"],
      authorizationSiteResource: "qaChecklist",
    },
    props: (route) => {
      return {
        id: parseInt(route.params.id.toString(), 10),
      };
    },
  },
];
export default router;
